import { createAction } from '@reduxjs/toolkit';
export const getDomainIdentity = createAction('login/getDomainIdentity');
export const getDomainIdentityResolved = createAction('login/getDomainIdentity/resolved');
export const getDomainIdentityRejected = createAction('login/getDomainIdentity/rejected');
export const resetDomainIdentity = createAction('login/resetDomainIdentity');
export const enableAuthStage = createAction('login/enableAuthStage');
